const PlayVideoOnScrollView = () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const el = entry.target;

      // Handle iframe (YouTube/Vimeo)
      if (el.tagName === "IFRAME") {
        const hasSrc = el.getAttribute('src');
        const dataSrc = el.getAttribute('data-src');

        if (dataSrc && !hasSrc) {
          el.setAttribute('src', dataSrc);
        }
      }

      // Handle self-hosted video
      if (el.tagName === "VIDEO") {
        if (el.paused) {
          el.muted = true;
          el.play().catch(err => {
            console.warn('Autoplay failed:', err);
          });
        }
      }
    });
  }, { threshold: 0.5 });

  const iframes = document.querySelectorAll("iframe.external-video");
  const videos = document.querySelectorAll("video.shopify-video");

  iframes.forEach(el => observer.observe(el));
  videos.forEach(el => observer.observe(el));
};

window.addEventListener('DOMContentLoaded', PlayVideoOnScrollView);


const CustomProductTopContents = () => {
  const mainProductContainer = document.querySelector('.product');
  const screenWidth = window.innerWidth

  if(!mainProductContainer) return;
  
  const cstmText1 = mainProductContainer.querySelector('.cstm-text-1');
  const productTitle = mainProductContainer.querySelector('.product__title');
  const cstmText2 = mainProductContainer.querySelector('.cstm-text-2');
  const cstmText3 = mainProductContainer.querySelector('.cstm-text-3');

  const topElementsContainer = document.createElement('div');
  topElementsContainer.classList.add('cstm-mobile-top-elements');

  if(screenWidth < 768) {
    cstmText1 && topElementsContainer.appendChild(cstmText1);
    productTitle && topElementsContainer.appendChild(productTitle);
    cstmText2 && topElementsContainer.appendChild(cstmText2);
    cstmText3 && topElementsContainer.appendChild(cstmText3);
  
    mainProductContainer.prepend(topElementsContainer);
  }
}

window.addEventListener('DOMContentLoaded', CustomProductTopContents);
window.addEventListener('resize', CustomProductTopContents);


const CSTMVideoSection = () => {
  const sections = document.querySelectorAll('.cstm-video-slider');
  const modal = document.getElementById('videoModal');
  const modalBody = modal.querySelector('.video-modal-body');
  const closeBtn = modal.querySelector('.video-modal-close');
  const backdrop = modal.querySelector('.video-modal-backdrop');

  const openModal = (content) => {
    // Create a temporary container
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;
  
    const iframe = tempDiv.querySelector('iframe');
    if (iframe) {
      let src = iframe.getAttribute('src');
  
      if (src.includes('youtube.com')) {
        // Add autoplay=1 and mute=0
        if (src.includes('autoplay=0')) {
          src = src.replace('autoplay=0', 'autoplay=1&mute=0');
        } else {
          src += (src.includes('?') ? '&' : '?') + 'autoplay=1&mute=0';
        }
      } else if (src.includes('vimeo.com')) {
        // Add autoplay=1 and mute=0
        if (src.includes('autoplay=0')) {
          src = src.replace('autoplay=0', 'autoplay=1&muted=0');
        } else {
          src += (src.includes('?') ? '&' : '?') + 'autoplay=1&muted=0';
        }
      }
  
      iframe.setAttribute('src', src);
    }
  
    const video = tempDiv.querySelector('video');
    if (video) {
      video.setAttribute('autoplay', 'true');
      video.removeAttribute('muted');
      video.play().catch((e) => {
        console.warn('Autoplay failed:', e);
      });
    }
  
    modalBody.innerHTML = tempDiv.innerHTML;
    modal.classList.remove('hidden');
  };

  const closeModal = () => {
    modal.classList.add('hidden');
    modalBody.innerHTML = '';
  };

    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);

  if(sections.length === 0) return;

  sections.forEach(section => {
    const slider = section.querySelector('.section-slider');
    const prev = section.querySelector('.prev');
    const next = section.querySelector('.next');
  
    const options = {
      slidesPerView: 'auto',
      spaceBetween: 6,
      navigation: {
        prevEl: prev,
        nextEl: next
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 16
        }
      }
    }

    const swiper = new Swiper(slider, options);

    const popupTriggers = section.querySelectorAll('.video-popup-trigger');

    if(popupTriggers.length > 0) {
      popupTriggers.forEach(trigger => {
        const content = trigger.dataset.popupContent;
      
        trigger.addEventListener('click', () => {
          openModal(content);
        });
      })
    }
  });
}

window.addEventListener('DOMContentLoaded', CSTMVideoSection);
window.addEventListener('shopify:section:load', CSTMVideoSection);
window.addEventListener('shopify:section:unload', CSTMVideoSection);
window.addEventListener('shopify:section:select', CSTMVideoSection);
window.addEventListener('shopify:section:unselect', CSTMVideoSection);
window.addEventListener('shopify:block:load', CSTMVideoSection);
window.addEventListener('shopify:block:unload', CSTMVideoSection);
window.addEventListener('shopify:block:select', CSTMVideoSection);
window.addEventListener('shopify:block:unselect', CSTMVideoSection);
